module.exports = __webpack_public_path__ + "img/1f619.b69ee00.svg";